import React, {useContext, useEffect} from "react";
import {Box, Stack, Typography} from "@mui/material";
import {
  CONTEXT_ACTION_TYPE,
  DataStoreContext,
  STEP_ORDERS,
  STEPS,
  useStep,
  WorkClassPayload
} from "../../contexts/OperatingTestContext";
import {WORK_ATTRS} from "../../../../constants/work";
import {FetchMessage} from "../../../../hooks/useFetchAllQuery";
import {convertToWorkDocuments, excludeClassesWithChildren, sortWorkClass} from "../../../../utils/workUtil";
import WorkClassListItem from "../lists/WorkClassListItem";
import useRepresentativeModel from "../../../workdb/hooks/useRepresentativeModel";
import {WORK_SORT_ORDER, WorkSortOrderValue} from "../../../../constants/constants";
import SortOrder from "../forms/SortOrder";

export default function WorkClassSelectionStep() {
  if (!useIsShow()) {
    throw new Error('WorkClassSelectionStep is not shown');
  }

  const {state, dispatch} = useContext(DataStoreContext);
  const [, setStep] = useStep();

  const workClasses = sortWorkClass(
    excludeClassesWithChildren(convertToWorkDocuments(state.workClassStep.workClasses)),
    state.workClassStep.searchCond.sortOrder
  );

  const {models, isLoading} = useRepresentativeModel({
    workClasses,
    acquiredRepresentativeModels: state.workClassStep.workRepresentativeModels,
  });
  useEffect(() => {
    dispatch({
      type: CONTEXT_ACTION_TYPE.WORK_CLASS,
      payload: {
        workRepresentativeModels: models,
      } satisfies WorkClassPayload
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [models]);



  return (
    <Stack gap={4}>
      <Box display='flex' flexWrap='nowrap' justifyContent='space-between' alignItems='center'>
        <Typography variant="subtitle1" sx={{fontWeight: "bold"}}>
          検索結果一覧
        </Typography>
        <Box display='flex' alignItems='center' gap={2}>
          <Box>
            {workClasses.length > 0 ? `${workClasses.length.toLocaleString()}件` : ""}
          </Box>
          <SortOrder
            value={state.workClassStep.searchCond.sortOrder}
            onChange={(event) => {
              dispatch({
                type: CONTEXT_ACTION_TYPE.WORK_CLASS,
                payload: {
                  searchCond: {
                    ...state.workClassStep.searchCond,
                    sortOrder: event.target.value as WorkSortOrderValue
                  },
                } satisfies WorkClassPayload
              });
            }}
            items={Object.values(WORK_SORT_ORDER)}/>
        </Box>
      </Box>

      <Box>
        <Box display='flex' flexWrap='wrap' gap={2}>
          {workClasses.map(workClass => (
            <Box
              key={workClass.attr[WORK_ATTRS.classId.key]}
              onClick={() => {
                dispatch({
                  type: CONTEXT_ACTION_TYPE.WORK_CLASS,
                  payload: {
                    selectedWorkClass: workClass,
                  } satisfies WorkClassPayload
                });
                setStep(STEP_ORDERS[STEPS.WORK_CLASS_SELECTION].NEXT);
              }}
            >
              <WorkClassListItem
                work={workClass}
                representativeModels={state.workClassStep.workRepresentativeModels}
                isLoading={isLoading}
              />
            </Box>
          ))}
        </Box>
        <FetchMessage
          data={state.workClassStep.workClasses}
          status={state.workClassStep.searchStatus}
          isEmpty={(items) => items.flatMap((item) => Object.keys(item.items)).length === 0}
        />
      </Box>
    </Stack>
  );
}

function useIsShow() {
  const {state} = useContext(DataStoreContext);
  return state.step === STEPS.WORK_CLASS_SELECTION;
}
